import styled, { css } from 'styled-components';
import { rem } from '~/src/helpers/rem-converter.helper';
import { mediaQuery } from '~/src/styles/mixins';
import { MAX_767 } from '~/src/styles/tokens/break-points';
import { FONTS } from '~/src/styles/style-helpers/font-helper';

export const PageNotLoadContainer = styled.main`
    width: 100%;
    min-height: ${rem(668)};
    display: flex;
    padding-top: ${rem(143)};
    padding-bottom: ${rem(238)};
    justify-content: center;

    ${mediaQuery({ maxWidth: MAX_767 }, css`
        min-height: ${rem(568)};
    `,)};
`;

export const ContentWrapper = styled.div`
    gap: ${rem(47)};
    flex-direction: column;
    align-items: center;
`;

export const TextContainer = styled.div`
    flex-direction: column;
    gap: ${rem(16)};
    align-items: center;
`;

export const TitleNotLoad = styled.h3`
    ${FONTS.sans.bold.size24};
`;

export const SubText = styled.span`
    ${FONTS.compact.regular.size17};
`;